<template>
  <div id="endDeviceOverview">
    <div class="row">
      <div class="col-lg-4 mb-3">
        <properties :end-device="endDevice" />
        <activation :end-device="endDevice" />
        <override-rx-parameters :end-device="endDevice" />
      </div>

      <div class="col-lg-8">
        <position :end-device="endDevice" :cluster="cluster" />
        <last-messages :end-device="endDevice" />

        <div class="row">
          <div class="col-lg-6"><last-gateways :end-device="endDevice" /></div>
          <div class="col-lg-6"><last-events :end-device="endDevice" /></div>
        </div>
      </div>
    </div>

    <floating-button v-if="isRole.admin" :click-handler="editEndDevice" icon-classes="icon-edit" />
    <end-device-form v-model="showEndDeviceForm" :end-device-to-edit="endDeviceToEdit" @success="getEndDevice" />
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

import Properties from './Properties'
import Activation from './Activation'
import OverrideRxParameters from './OverrideRxParameters'
import LastGateways from './LastGateways'
import Position from './Position'
import LastMessages from './LastMessages'
import LastEvents from './LastEvents'

import EndDeviceForm from './EndDeviceForm'

export default {
  titleKey: 'endDeviceOverview',

  components: {
    Properties,
    Activation,
    OverrideRxParameters,
    LastGateways,
    Position,
    LastMessages,
    LastEvents,
    EndDeviceForm
  },

  props: {
    devEui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      cluster: {},
      // Edit
      showEndDeviceForm: false,
      endDeviceToEdit: {}
    }
  },

  computed: {
    ...mapGetters(['endDevice', 'customerAllClusters'])
  },

  watch: {
    endDevice () {
      if (!this.endDevice || !this.endDevice.cluster.id) return

      // update the selection after refreshing the endDevice
      if (this.$store.getters.isEndDeviceInSelection(this.endDevice)) {
        this.$store.commit('removeEndDeviceFromSelection', this.endDevice)
        this.$store.commit('addEndDeviceInSelection', this.endDevice)
      }

      this.getCluster()
    },

    showEndDeviceForm () {
      // Empty form when hidding modal
      if (!this.showEndDeviceForm) this.endDeviceToEdit = {}
    }
  },

  created () {
    this.getCluster()
  },

  methods: {
    async getCluster () {
      if (isEmpty(this.endDevice)) return

      let error, response
      [error, response] = await to(this.$api.getCluster(this.endDevice))
      if (error || !response) return

      this.cluster = response.data
    },

    getEndDevice () {
      return this.$store.dispatch('getEndDevice', this.devEui)
    },

    editEndDevice () {
      this.endDeviceToEdit = this.endDevice
      this.showEndDeviceForm = true
    }
  }
}
</script>
